import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isCaseStudyAuthenticated } from '../../utils/caseStudyAuth';

/**
 * Wrapper for protected case study routes. Does not render content until the user
 * has passed the password page. Redirects to /password?redirect=... when not authenticated.
 */
export default function ProtectedCaseStudy({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (isCaseStudyAuthenticated()) {
      setAllowed(true);
    } else {
      const redirect = encodeURIComponent(location.pathname);
      navigate(`/password?redirect=${redirect}`, { replace: true });
    }
  }, [location.pathname, navigate]);

  if (!allowed) {
    return null;
  }

  return children;
}